<template>
  <el-dialog title="选择认证名称"
             :close-on-click-modal="false"
             :show-close="true"
             :visible.sync="visible"
             width="600px"
             :before-close="dialogClose">
    <el-card shadow="never"
             class="aui-card--fill">
      <el-form label-position="left"
               label-width="auto"
               :model="dataForm">
        <el-row class="margb10">
          <el-col :span="15">
            <el-form-item :label="$t('cert.certName')">
              <el-input v-model="dataForm.dictName"
                        :placeholder="$t('cert.pleaseInputcertName')"
                        clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2">&nbsp;</el-col>
          <el-col :span="7">
            <el-button style="margin-bottom: 7px" class="M-search" @click="queryDictList()" type="primary">{{ $t('query') }}</el-button>
          </el-col>
        </el-row>
        <el-row class="margb10">
          <el-col :span="7">
            <el-button type="primary" class="el-back M-search M-margin-l" @click="certNameOk">{{$t('confirm')}}</el-button>
          </el-col>
          <el-col :span="10">&nbsp;</el-col>
          <el-col :span="7">
            <el-button class="el-back M-search M-margin-l" type="info" @click="resetQuery">{{$t('reset')}}</el-button>
          </el-col>
        </el-row>
      </el-form>
      <div class="selectCertNameClass">
      <el-table v-loading="dataListLoading"
                :data="dataList"
                border
                height="350"
                @selection-change="selectCertName"
                style="width: 100%;"
                ref="selectDictinfo">
        <el-table-column type="selection"
                         header-align="center"
                         align="center"
                         width="50"></el-table-column>
        <el-table-column v-if="false"
                         prop="dictValue"
                         :label="$t('dict.dictValue')"
                         header-align="center"
                         align="center"></el-table-column>
        <el-table-column prop="dictNameCn"
                         :label="$t('cert.certName')"
                         header-align="center"
                         align="left"></el-table-column>
      </el-table>
      </div>
      <el-pagination :current-page="page"
                     :page-sizes="[10, 20, 50, 100]"
                     :page-size="limit"
                     :total="total"
                     layout="total, sizes, prev, pager, next, jumper"
                     @size-change="pageSizeChangeHandle"
                     @current-change="pageCurrentChangeHandle">
      </el-pagination>
    </el-card>
  </el-dialog>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
export default {
  mixins: [mixinViewModule],
  name: 'selectCertName',
  data () {
    return {
      mixinViewModuleOptions: {
        activatedIsNeed: false,
        getDataListURL: '/sys/commdict/list',
        getDataListIsPage: true,
        deleteURL: '/sys/commdict/delete',
        deleteIsBatch: true
      },
      dataForm: {
        dictName: '',
        dictType: '',
        dictValue: ''
      },
      // 等待转圈
      dataListLoading: false,
      dictData: []
    }
  },
  props: {
    visible: {// 是否显示
      type: Boolean,
      required: false,
      default: false
    },
    dictType: {// 字典类型
      type: String,
      required: true
    }
  },
  methods: {
    initMethods () {
      this.resetQuery()
      this.queryDictList()
    },
    init () {
      this.visible = true
      this.loading = false
    },
    dialogClose (done) {
      this.$emit('dictOk')
      done()
    },
    // 查询
    queryDictList () {
      let _this = this
      _this.page = 1
      _this.getDataList()
    },
    // 双击选择字典数据
    certNameOk () {
      let select = this.$refs.selectDictinfo.selection
      if (select.length <= 0) {
        this.$message.warning(this.$t('cert.pleaseSelectCertName'))
        return false
      }
      this.$emit('dictOk', select[0])
    },
    // 获取数据列表
    getDataList () {
      let newDataForm = JSON.parse(JSON.stringify(this.dataForm))
      if ('regionIds' in newDataForm) {
        if (newDataForm.regionIds.length === 0) {
          newDataForm.regionIds = ''
        } else {
          newDataForm.regionIds = newDataForm.regionIds.join(',')
        }
      }
      this.dataListLoading = true
      this.$request.get(
        this.mixinViewModuleOptions.getDataListURL,
        {
          order: this.order,
          orderField: this.orderField,
          page: this.mixinViewModuleOptions.getDataListIsPage ? this.page : null,
          limit: this.mixinViewModuleOptions.getDataListIsPage ? this.limit : null,
          ...newDataForm
        }
      ).then((res, total, code, data) => {
        this.dataListLoading = false
        let resultList = data.data.records
        this.dataList = []
        if (resultList) {
          for (var i = 0; i < resultList.length; i++) {
            if (resultList[i].pid !== 0 && resultList[i].pid !== null) {
              this.dataList.push(resultList[i])
            }
          }
        }
        // this.dataList = resultList
        this.total = this.mixinViewModuleOptions.getDataListIsPage ? parseInt(data.data.total, 10) : 0
      }).catch(() => {
        this.dataListLoading = false
      })
    },
    selectCertName (selection) {
      if (selection.length > 1) {
        this.$refs.selectDictinfo.clearSelection()
        this.$refs.selectDictinfo.toggleRowSelection(selection.pop())
      }
    },
    // 重置查询条件
    resetQuery () {
      this.dataForm = {
        dictName: '',
        dictType: '',
        dictValue: ''
      }
      this.dataForm.dictType = this.dictType
    }
  }
}
</script>
<style>
.selectCertNameClass thead .el-table-column--selection .cell {
  display: none !important;
}
</style>
